import { render, staticRenderFns } from "./ComplaintEdit.vue?vue&type=template&id=4ede453b&"
import script from "./ComplaintEdit.vue?vue&type=script&lang=js&"
export * from "./ComplaintEdit.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports